var map = {
	"./account-management.png": 72186,
	"./account-management.svg": 32286,
	"./archived_req.svg": 5482,
	"./dash.png": 6277,
	"./dash.svg": 67437,
	"./edf_job_manager.png": 39978,
	"./edf_job_manager.svg": 76964,
	"./master-data.png": 69310,
	"./master-data.svg": 62924,
	"./new-req.png": 32856,
	"./new-req.svg": 66046,
	"./patients.png": 93419,
	"./patients.svg": 78335,
	"./pipline.png": 23892,
	"./pipline.svg": 63366,
	"./release-req.png": 73605,
	"./release-req.svg": 5015,
	"./search.png": 80893,
	"./search.svg": 41497,
	"./user-management.png": 3482,
	"./user-management.svg": 71852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8969;